
import Teleport from 'vue2-teleport';
import { Drawer } from 'element-ui';
import cartMixin from '@/mixins/cartMixin.js';
export default {
  props: {
    variants: {
      type: Array,
    },
    product: {
      type: Object,
    },
    variantSelected: {
      type: Object,
      default: null,
    },
  },
  mixins: [cartMixin],
  data() {
    return {
      drawer: false,
      selectedVariantForNotification: null,
    };
  },

  computed: {
    productTitle() {
      if (this.product != null) {
        try {
          return this.product.Description.Title;
        } catch (error) {}
      }
      return '';
    },

    promotion() {
      let price = this.product.Price;
      return price.PromotionalPrice;
    },
    promotionPercentage() {
      const price = Number(this.productPrice);
      const pricePromotion = Number(this.productPricePromotion);

      return ((1 - pricePromotion / price) * 100).toFixed(0);
    },
    productPricePromotion() {
      return this.promotion.PriceTaxIncl;
    },
    productPrice() {
      if (this.promotion) {
        return this.productPricePromotion;
      }
      return this.product.Price.RegularPrice.PriceTaxIncl;
    },

    mainCatgoryTitle() {
      try {
        const seo = this.product?.Category?.Main?.SEO;
        if (seo) {
          const mainCategory = seo.find((item) => {
            return this.$i18n.locale === item.LanguageIsoCode.toLowerCase();
          });
          if (!mainCategory) {
            return null;
          }
          if (mainCategory.MetaTitle) {
            return mainCategory.MetaTitle;
          }
        }
      } catch (error) {}
      return null;
    },
  },
  methods: {
    getAttrs(variant) {
      let att = {};
      variant?.Combination?.Attributes?.map((item) => {
        if (item.GroupName === 'Color') {
          att = {
            ...att,
            ...{
              color: item,
            },
          };
        } else if (item.GroupName === 'Size') {
          att = {
            ...att,
            ...{
              size: item,
            },
          };
        }
      });

      return att;
    },
    addToCart(variant) {
      const idProductAttributeSelected = variant.Combination.IdProductAttribute;

      this.cartService
        .addToCart({
          idCart: this.cart.IdCart,
          product: this.product,
          idProductAttribute: idProductAttributeSelected,
        })
        .then((data) => {
          this.cartService.fetchCart({
            onSuccess: (data) => {
              this.drawer = false;
              this.openRightBarCart();
            },
          });

          // this.$gtag.event('add_to_cart', {
          //   items: [
          //     {
          //       item_id: this.product.IdProduct,
          //       quantity: 1,
          //     },
          //   ],
          // });

       
        });
    },
    openDrawer() {
      this.drawer = true;
    },
    handleNotAvailable(variant) {
      this.selectedVariantForNotification = variant;
    },
  },
  components: {
    Teleport,
    Drawer,
    ProductNotAvailable: () =>
      import('@/components/products/ProductNotAvailable.vue'),
  },
};
